import {gql} from "@apollo/client";

export const RERUN_JOB_STEP_RUN = gql`
	mutation reRunJobStepRun ($jobStepRunId: Int!, $failedOnly: Boolean!) {
		reRunJobStepRun(input: {id: $jobStepRunId, failedOnly: $failedOnly}) {
		   reRunJobStepRun {
				success
			}
			errors {
				... on ArgumentError {
					message
				}
			}
		}
	}
`;
